var TicketType = /** @class */ (function () {
    function TicketType() {
    }
    return TicketType;
}());
export default TicketType;
